import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { ClientDtoKeysEnum } from '@zaoblako/shared/modules/client/enums/client-dto-keys.enum';
import { type RoleFindInterface, RoleFindDto } from '@zaoblako/shared/modules/security/dtos/role/role-find.dto';
import { type CompanyFindInterface, CompanyFindDto } from '@zaoblako/shared/modules/client/dtos/company/find/company-find.dto';

import * as yup from 'yup';

export interface CompanyGroupFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;
  /** Company group display name */
  name: string;
  /** Company group creation date and time */
  created: Date;
  /** Company group last update date and time */
  updated: Date;
  /** Is company deleted */
  deleted?: Date;
  /** Roles of users who have access to companies from this group */
  roles?: RoleFindInterface[];
  /** Companies in this group */
  companies?: CompanyFindInterface[];
}

export const CompanyGroupFindDto = SerdeDtoClass.create<CompanyGroupFindInterface>(ClientDtoKeysEnum.COMPANY_GROUP_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  name: {
    label: 'Имя',
    serializer: yup.string(),
  },
  created: {
    label: 'Создан',
    serializer: yup.date(),
  },
  updated: {
    label: 'Обновлён',
    serializer: yup.date(),
  },
  deleted: {
    optional: true,
    label: 'Удалён',
    serializer: yup.date(),
  },
  roles: {
    optional: true,
    label: 'Роли',
    nested: RoleFindDto,
    serializer: (_, nested) => yup.array(nested),
  },
  companies: {
    optional: true,
    label: 'Компании',
    nested: CompanyFindDto,
    serializer: (_, nested) => yup.array(nested),
  },
});
